export const isRedirectUrlValid = (redirectUrl: string | string[]): boolean => {
  if (Array.isArray(redirectUrl)) {
    return false
  }
  return Boolean(
    redirectUrl.match(/^https?:\/\/(\w*\.)?(hubpreprod|hublo)\.com((\/.*)|$)$/),
  )
}
